import {
  IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip
  } from "@material-ui/core";
  
  import React from "react";
  import { uniqBy } from "lodash/array";
  import { API_URL } from "../../../../constants/api";
  import {
    apiPut,
    apiRequest
  } from "../../../../utils/api_service";
  import {
    SECTIONS,
    SECURITY_SETTINGS_HEADER,
    getSecuritySettingColumn
  } from "../../../../constants/appConstants";
  import TableWithFilter from "../../../common/Table/TableWithFilter";
  import { convertIntoDDFormat } from "../../../../utils/generic";
  import { ShowToast, toastType } from "../../../../utils/toast-service";
  import { IsSectionVisible, isGridFormValid } from "../../../../utils/helper";
  import commonLabels from "../../../../constants/messageConstants"
  import _ from "lodash";
  import SaveIcon from "@material-ui/icons/Save";
  import CancelIcon from "@material-ui/icons/Cancel";


  export default class SecurityStatusMaintenance extends React.PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        colFilteredObj: [],
        statusData: [],
        isInAddMode: false,
        statusColumns: [],
        validationMessage: [],
        selectedEditRowId: undefined
      };
    }
  
    componentDidMount() {
      this.getStatusConfigurations();
    }
    
    /**
     * get routing configuration data
     */
    getStatusConfigurations = () => {
      const params = { incidentParam: "Status" };
      apiRequest({
        url: API_URL.securityIncident.GetSecurityIncidentMasterDataConfiguration,
        params
      }).then(
        ({ data: response }) => {
          const { colFilteredObj } = this.state
          const statusMasterData = uniqBy(
            convertIntoDDFormat(
              response || [],
              "IncidentStatusId",
              "IncidentStatus"
            ),
            x => x.id
          );
          const optionsListForStatus = convertIntoDDFormat(
            statusMasterData || [],
            "value",
            "value"
          );
          const columns = getSecuritySettingColumn(colFilteredObj, {
            statusMasterData: optionsListForStatus
          });
          this.setState({
            statusData: response,
            statusColumns: columns
          });
        }
      );
    };
    
    /**
     * Add new record
     * @returns 
     */
    AddNewRecord = () => {
      const { isInAddMode, reloadTable, statusColumns } = this.state;
      if (isInAddMode) {
        ShowToast("You can add one row at a time!", toastType.WARNING, 5000, 500);
        return false;
      }
      const newStatusColumns = _.cloneDeep(statusColumns);
      const rowNew = {
        IncidentStatusId: 0,
        IncidentStatus: null,
        IsActive: "Yes"
      };
  
      this.setState({
        isInAddMode: true,
        selectedEditRowId: { key: "IncidentStatusId", value: 0 },
        reloadTable: !reloadTable,
        updateData: rowNew,
        statusColumns: newStatusColumns
      });
    };

    /**
     * activate and deactivate the security status maintenance record
     */
    activateDeactivateRecord = (data) => {
      const params = {
        IncidentStatusId: data.IncidentStatusId,
        isActive: data.IsActive === "Yes" ? 2 : 1
      }
      apiPut({
        url: API_URL.securityIncident.ModifySecurityIncidentStatus,
        params
      }).then(({ data: response }) => {
        response.success != true
          ? ShowToast(
              "Server Error: Unable to update status.",
              toastType.ERROR,
              5000,
              500
            )
          : ShowToast(
              "Security Status updated successfully.",
              toastType.SUCCESS,
              5000,
              200
            );
  
        this.getStatusConfigurations();
      });
    }

   /**
   * handle on change
   * @param {*} value
   * @param {*} fieldName
   */
    handleTableEditChange = (value, fieldName) => {
        const { statusColumns, updateData, validationMessage } = this.state;
        const param = updateData;
        param[fieldName] = value;

        isGridFormValid(value, statusColumns.find(x => x.key === fieldName), param);

        this.setState({ updateData: param, validationMessage: (validationMessage || []).filter(x => { return x.key !== fieldName; }) }, () => {
          this.forceUpdate();
        });
    };

    /**
    * render action column on grid table
    * @param {*} cellInfo
    * @returns
    */
    renderActionColumn = (cellInfo) => {
      const { selectedEditRowId } = this.state;
      return (
        <>
          {selectedEditRowId !== undefined &&
            cellInfo.IncidentStatusId === selectedEditRowId.value
            && (
              <>
                <Tooltip title={"Save Record"}>
                  <IconButton
                    aria-label={"refreshData"}
                    size={"small"}
                    onClick={() => { }}
                  >
                    <SaveIcon
                      fontSize={"small"}
                      size={"small"}
                      onClick={this.saveUpdatedRecord}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title={"Cancel"}>
                  <IconButton
                    aria-label={"refreshData"}
                    size={"small"}
                    onClick={this.cancelEditMode}
                  >
                    <CancelIcon fontSize={"small"} size={"small"} />
                  </IconButton>
                </Tooltip>
              </>
            )}
        </>
      );
    };

   /**
   * cancel row open for edit mode
   */
    cancelEditMode = () => {
      const { reloadTable } = this.state
      this.setState({
        selectedEditRowId: undefined,
        isInAddMode: false,
        updateData: undefined,
        reloadTable: !reloadTable
      });
      this.getStatusConfigurations();
    };

   /**
   * save Updated Record to database
   */
    saveUpdatedRecord = () => {
      const { updateData, reloadTable } = this.state;
      if (!this.isValidForm()) { return false; } 
      else if (this.isAlreadyExist(updateData)){
        return false
      }
      else {
        const newParam = {
          IncidentStatus: updateData.IncidentStatus,
          IncidentStatusId: updateData.IncidentStatusId,
          listOrderBy: Math.floor(Number(updateData.ListOrderBy))
        };
          apiPut({
            url: API_URL.securityIncident.SaveSecurityIncidentStatus,
            postBody: newParam
          }
          ).then(({ data: response }) => {
            if (response.success === true) {
              ShowToast(
                updateData.IncidentStatusId > 0 ? "Record updated successfully." : "Record added successfully.",
                toastType.SUCCESS,
                5000,
                500
              );

              this.setState({
                updateData: undefined,
                selectedEditRowId: undefined,
                reloadTable: !reloadTable,
                isInAddMode: false
              }, () => {
                this.getStatusConfigurations();
                this.forceUpdate();
              });
            } else {
              ShowToast(
                response.message,
                toastType.ERROR,
                5000,
                5000
              );
            }
          });
        }
      
    };

    /**
   * is Form Valid
   */
    isValidForm = () => {
      let IsValid = true;
      const { updateData, statusColumns } = this.state;
      statusColumns.forEach((ele) => {
        isGridFormValid(updateData[ele.key], ele, updateData);
        if (ele.isInErrorState === true) {
          IsValid = false;
        }
      });
      this.setState({ statusColumns }, this.forceUpdate());
      return IsValid;
    };

    /**
     * edit the record
     * @param {*} cellInfo 
     */
    editRecord = (cellInfo) => {
      const { statusColumns, reloadTable } = this.state;
      const newStatusColumns = _.cloneDeep(statusColumns);
  
      this.setState({
        statusColumns: newStatusColumns,
        selectedEditRowId: {
          key: "IncidentStatusId",
          value: cellInfo.IncidentStatusId
        },
        isInAddMode: false,
        updateData:  { ...cellInfo },
        reloadTable: !reloadTable
      });
    }

    /**
     * check for exists in the system
     * @param {*} data 
     * @returns 
     */
    isAlreadyExist = (data) => {
      const { statusData } = this.state;
      let fieldName = "";
      let isExist = false;
       if(statusData.find(x=> x.IncidentStatus === data.IncidentStatus && x.IncidentStatusId !== data.IncidentStatusId) !== undefined) {
        fieldName = "Incident Status";
        isExist = true;
       } 
       if(statusData.find(x=> parseInt(x.ListOrderBy) === parseInt(data.ListOrderBy) && x.IncidentStatusId !== data.IncidentStatusId) !== undefined) {
        fieldName += fieldName === "" ? "List Order by" : ", List Order by";
        isExist = true;
       } 
       if (fieldName != "" && isExist) {
        ShowToast(
          fieldName + " already exist in the system.",
          toastType.ERROR,
          5000,
          500
        );
       }
       return isExist;
    }

    render() {
      const {
        statusData,
        selectedEditRowId,
        updateData,
        isInAddMode,
        reloadTable,
        validationMessage
      } = this.state;
     const {tooltip}=this.props
      let { statusColumns } = this.state;
      const isVisible = IsSectionVisible(
        SECTIONS.CONFIGURATION,
        SECTIONS.CONFIGURE_ROUTING_AND_NOTIFICATION,
        SECTIONS.ADD_EDIT
      );
      statusColumns = !isVisible
        ? statusColumns.filter(x => x.colName !== "Action")
        : statusColumns;
  
      return (
        <>
          <Table
            aria-labelledby={"tableMenuTitle"}
            size={"small"}
            aria-label={"configuration table"}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  key={"configureHeader"}
                  className={"content-header"}
                  colSpan={2}
                >
                  <div className={"content-header d-flex"}>
                    {" "}
                    <div
                      className={"col-xs-11"}
                      style={{ display: "inline-block", alignItems: "center" }}
                    >
                      {"Security Status Maintenance Configuration\r"}
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <TableWithFilter
                    renderActionColumn={this.renderActionColumn}
                    selectedEditRowId={selectedEditRowId}
                    isInAddMode={isInAddMode}
                    EditSource={[]}
                    handleTableValueChange={this.handleTableEditChange}
                    updateData={updateData}
                    deactivationMessage={commonLabels.deactivationForStatusConfirmation.message}
                    activationMessage={commonLabels.activationForStatusConfirmation.message}
                      visibilityAction={{
                        isActionVisible: isVisible
                      }}
                      AddNewRecord={{
                        action: this.AddNewRecord,
                        title: "Add Security Status",
                        visible: true
                      }}
                      activateDeactivateRecord={this.activateDeactivateRecord}
                      tableHeader={SECURITY_SETTINGS_HEADER}
                      columns={statusColumns}
                      originalData={statusData}
                      reloadTable={reloadTable}
                      resetPage={this.getStatusConfigurations}
                      validationMessage={validationMessage || []}
                      isInline
                      editRecord={this.editRecord}
                      toolTipData={tooltip}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </>
      );
    }
  }
  